import type { RestService } from '../rest-service';

/**
 * Base API for the creation of others.
 */
export class API {
  protected restService: RestService;

  /**
   * @param restService - Instance of the RestService class.
   */
  constructor(restService: RestService) {
    this.restService = restService;
  }

  /**
   * Gets the RestService associated with this instance.
   * @returns RestService object
   */
  getRestService(): RestService {
    return this.restService;
  }
}
